export const DATE_TIME_PICKER_TEST_IDS = {
  // ── Wrapper / trigger ────────────────────────────────────────────────
  PICKER_WRAPPER: 'date-picker-wrapper',
  TOGGLE_BTN: 'date-picker-toggle-btn',
  CLEAR_BTN: 'date-picker-clear-btn',

  // ── Popup ────────────────────────────────────────────────────────────
  POPUP_CLOSE_BTN: 'date-picker-popup-close-btn',
  POPUP_RANGE_INFO: 'date-picker-popup-range-info',
  POPUP_RESET_BTN: 'date-picker-popup-reset-btn',
  POPUP_CANCEL_BTN: 'date-picker-popup-cancel-btn',
  POPUP_APPLY_BTN: 'date-picker-popup-apply-btn',

  // ── Shortcuts panel ──────────────────────────────────────────────────
  SHORTCUTS_MODE_CONTROL: 'date-picker-shortcuts-mode-control',
  SHORTCUTS_BTN: (label: string) =>
    `date-picker-shortcut-btn-${label.toLowerCase().replace(/\s+/g, '-')}`,

  // ── Calendar ─────────────────────────────────────────────────────────
  CALENDAR_VIEW: 'date-picker-calendar-view',
  CALENDAR_PREV_BTN: 'date-picker-calendar-prev-btn',
  CALENDAR_NEXT_BTN: 'date-picker-calendar-next-btn',
  CALENDAR_DAY_BTN: (date: string) => `date-picker-calendar-day-${date}`,

  // ── Time selector ────────────────────────────────────────────────────
  TIME_START_HOUR: 'date-picker-time-start-hour',
  TIME_START_MINUTE: 'date-picker-time-start-minute',
  TIME_START_QUICK: 'date-picker-time-start-quick',
  TIME_END_HOUR: 'date-picker-time-end-hour',
  TIME_END_MINUTE: 'date-picker-time-end-minute',
  TIME_END_QUICK: 'date-picker-time-end-quick',

  // ── Time dropdown options ────────────────────────────────────────────
  TIME_DROPDOWN_TRIGGER: (selector:string) =>
    `${selector}-dropdown-trigger`,
  TIME_DROPDOWN_OPTION: (id: string, value: string, selector:string) =>
    `${selector}-dropdown-option-${id}-${value}`,
} as const;
